import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  CanLoad,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
} from "@angular/router";
import { Observable, of } from "rxjs";
import { switchMap } from "rxjs/operators";
import { AuthService } from "app/core/auth/auth.service";

@Injectable({
  providedIn: "root",
})
export class NoAuthGuard implements CanActivate, CanActivateChild, CanLoad {
  constructor(private _authService: AuthService, private _router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this._check();
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this._check();
  }

  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> {
    return this._check();
  }

  private _check(): Observable<boolean> {
    return this._authService.check().pipe(
      switchMap((authenticated) => {
        if (authenticated) {
          this._router.navigate(["/profile-dashboard"]);
          return of(false);
        }
        return of(true);
      })
    );
  }
}
